import { render, staticRenderFns } from "./TouchRange.vue?vue&type=template&id=3acb3e5d&scoped=true&"
import script from "./TouchRange.vue?vue&type=script&lang=js&"
export * from "./TouchRange.vue?vue&type=script&lang=js&"
import style0 from "./TouchRange.vue?vue&type=style&index=0&id=3acb3e5d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb3e5d",
  null
  
)

export default component.exports